const timeOrderPercentCalc = (statsTimeOrder) => {
  let totalCount = 0
  let totalPrice = 0
  statsTimeOrder.forEach(stat => {
    totalCount += stat.count
    totalPrice += stat.sum
  })
  let prevItemTo = 0
  return statsTimeOrder.map(stat => {
    stat.timeFrom = prevItemTo
    prevItemTo = stat.timeTo
    stat.percentCount = totalCount > 0 ? stat.count / totalCount : null
    stat.percentSum = totalPrice > 0 ? stat.sum / totalPrice : null
    return stat
  })
}

export {timeOrderPercentCalc}



// WEBPACK FOOTER //
// ./src/helpers/timeOrdersPercentCalc.js